import { HubConnection } from "@microsoft/signalr";

type ReconnectHandler = () => void;

const reconnectHandlers = new WeakMap<HubConnection, Set<ReconnectHandler>>();
const registeredReconnectHubs = new WeakSet<HubConnection>();

export const addFleetManagerHubReconnectHandler = (
  hub: HubConnection,
  handler: ReconnectHandler
) => {
  let handlers = reconnectHandlers.get(hub);
  if (!handlers) {
    handlers = new Set<ReconnectHandler>();
    reconnectHandlers.set(hub, handlers);
  }

  handlers.add(handler);
  if (!registeredReconnectHubs.has(hub)) {
    registeredReconnectHubs.add(hub);
    hub.onreconnected(() => {
      reconnectHandlers.get(hub)?.forEach((currentHandler) => currentHandler());
    });
  }

  return () => handlers?.delete(handler);
};
